/**
 * The app's single dayjs instance, with the plugins the codebase needs.
 *
 * dayjs plugins are registered on a module-level singleton, so `extend` has to
 * run before any code calls a format token it provides. Importing dayjs from
 * here rather than from `'dayjs'` directly makes that ordering a consequence of
 * the import graph instead of something to remember -- `src/index.js` also
 * imports it so the registration happens once, up front, whatever loads first.
 *
 * `advancedFormat` is what supports the `Do` token (ordinal day: "1st",
 * "22nd"). It is the only token in the codebase that dayjs core does not
 * handle -- everything else in use (`DD`, `MMM`, `MMMM`, `YYYY`, `HH`, `hh`,
 * `mm`, `ss`, `A`, `a`, `D`, `MM`) is built in. Two call sites need it:
 * `'MMMM Do YYYY, h:mm:ss a'` and `'MMM Do YYYY, h:mm:ss a'`.
 *
 * Added when moment was removed. moment and dayjs agree on every other format
 * token this app uses, but they do NOT agree on lenient parsing, so prefer
 * passing epoch milliseconds or a real Date over a hand-built string.
 */
import dayjs from 'dayjs';
// The `.js` extension is required, not stylistic: `src/utils/package.json`
// declares `"type": "module"`, so webpack treats every file in this directory
// as strict ESM and refuses to resolve an extensionless subpath import.
import advancedFormat from 'dayjs/plugin/advancedFormat.js';

dayjs.extend(advancedFormat);

export default dayjs;
